import Home from '@/views/home'
import chart from '@/views/chart/index'
import content from '@/views/content/index'
import user from '@/views/user/index'
import error from '@/views/comPages/error'
import aboutUs from '@/views/comPages/aboutUs'

const routes = [
  {
    path: '/',
    redirect: '/chart',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/chart',
        name: 'Chart',
        meta: {
          noAuth: false,
        },
        component: chart,
      },
      {
        path: '/content',
        name: 'Content',
        meta: {
          noAuth: false,
        },
        component: content,
      },
      {
        path: '/user',
        name: 'User',
        meta: {
          noAuth: false,
        },
        component: user,
      }
    ],
  },
  {
    path: '/aboutUs',
    name: 'AboutUs',
    meta: {
      noAuth: false
    },
    component: aboutUs,
  },
  {
    path: '/error',
    name: 'error',
    meta: {
      noAuth: true, // 不需要授权
    },
    component: error,
  }
]

export default routes
